import ClassicalFileExplorer from './ClassicalFileExplorer';

export default ClassicalFileExplorer;
